module.exports = __webpack_public_path__ + "static/media/siddharth-big-banyan-tree-trip-02.8242fc89.png";